module.exports = __webpack_public_path__ + "06c146d3fe6f3ded16455fb768bc926f.jpg";